module.exports = __webpack_public_path__ + "media/images/emblems/Oberengstringen-blazon-f028e7322985467073e555ce25e6f482.svg";